import { Menu } from '@mui/material';
import React from 'react';

import { UserMenuProps } from './types';

export function UserMenu(props: UserMenuProps) {
    const {
        classes,
        menuItems,
        menuAnchor,
        handleMenuClose
    } = props;

    if (menuItems.length === 0) return null;

    return (
        <Menu
            anchorEl={menuAnchor}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            id='sidebar_user_menu'
            keepMounted
            onClose={handleMenuClose}
            open={Boolean(menuAnchor)}
            PopoverClasses={{ paper: classes.root }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
        >
            {menuItems}
        </Menu>
    );
}